import axios from "axios";
import { get } from "lodash";
import momentTZ from "moment-timezone";
import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const BANNER_ENDPOINT =
  "https://prod-maintenance-content.s3.us-west-2.amazonaws.com/insight-banner.md";

const logMessage = (...message: string[]) => {
  const isDebugEnabled =
    localStorage &&
    typeof localStorage.getItem === "function" &&
    localStorage.getItem("debug") === "true";

  if (isDebugEnabled) {
    // tslint:disable-next-line
    console.log(...message);
  }
};

const IssueBanner = () => {
  const [message, setMessage] = useState("");

  useEffect(() => {
    const runAsync = async () => {
      // Fetch banner
      const response: any = await axios.get(BANNER_ENDPOINT).catch(logMessage);
      const headers = get(response, "headers");
      const ZONE = "Australia/Sydney";

      const currentTime = momentTZ(headers.date).tz(ZONE);
      const startDate = momentTZ(headers["x-amz-meta-startdate"]).tz(ZONE);
      const endDate = momentTZ(headers["x-amz-meta-enddate"]).tz(ZONE);

      // Display banner content from banner file
      setMessage(
        currentTime >= startDate && currentTime <= endDate
          ? get(response, "data")
          : ""
      );
    };

    runAsync();
  }, []);

  return message ? (
    <div
      className="border-blue border m-5 bg-blue text-white align-middle text-center"
      style={{
        fontSize: "14px",
        padding: "6px",
      }}
    >
      {/* eslint-disable-next-line */}
      <ReactMarkdown children={message} remarkPlugins={[remarkGfm]} />
    </div>
  ) : null;
};

export default IssueBanner;
